import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { DriveConversationHostComponent } from './drive-conversation-host.component';

/**
 * Light wrapper for the explorer-style drive comment shell on org-level pages.
 * The heavy host (media-studio conversation + prosemirror + the drive sidebar)
 * is referenced only inside the `@defer` block, so it stays out of the initial
 * bundle — `child-layout` is eagerly declared in `AppModule` and must not pull
 * media-studio with it. `display: contents` keeps this wrapper out of the box
 * tree so the host's absolute overlay positions against `.root-layout`.
 */
@Component({
  selector: 'mtm-drive-comments-panel',
  standalone: true,
  imports: [DriveConversationHostComponent],
  template: `
    @defer (on immediate) {
      <mtm-drive-conversation-host
        [elementUuid]="elementUuid()"
        [entityName]="entityName()"
        [entityType]="entityType()"
        [reserveTarget]="reserveTarget()"
      />
    }
  `,
  styles: `
    :host {
      display: contents;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DriveCommentsPanelComponent {
  readonly elementUuid = input.required<string>();
  readonly entityName = input<string | null>(null);
  readonly entityType = input<string | null>(null);
  /** Layout row that receives the composer-height reserve (`--os-composer-h`) its content column sizes against. */
  readonly reserveTarget = input<HTMLElement | null>(null);
}
